import './ui.css';
import type { HTMLAttributes, ReactNode } from 'react';

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  /** Apply default inner padding. Default true. */
  pad?: boolean;
  /** Lift + border highlight on hover (for clickable cards). */
  hover?: boolean;
}

export function Card({ pad = true, hover, className, children, ...rest }: CardProps) {
  const cls = [
    'ui-card',
    pad && 'ui-card--pad',
    hover && 'ui-card--hover',
    className,
  ].filter(Boolean).join(' ');
  return (
    <div className={cls} {...rest}>
      {children}
    </div>
  );
}

export interface PanelProps extends Omit<HTMLAttributes<HTMLDivElement>, 'title'> {
  title?: ReactNode;
  actions?: ReactNode;
  children: ReactNode;
}

/** A card with an optional titled header (title + right-aligned actions). */
export function Panel({ title, actions, className, children, ...rest }: PanelProps) {
  return (
    <div className={`ui-panel${className ? ` ${className}` : ''}`} {...rest}>
      {(title || actions) && (
        <div className="ui-panel__header">
          {title && <h3 className="ui-panel__title">{title}</h3>}
          {actions && <div className="ui-panel__actions">{actions}</div>}
        </div>
      )}
      <div className="ui-panel__body">{children}</div>
    </div>
  );
}
